import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=48558a46&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewModal.vue?vue&type=style&index=0&id=48558a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48558a46",
  null
  
)

export default component.exports